import React, { FC, useEffect } from 'react';
import { Skeleton } from 'antd';
import { WarningCircle } from 'common/svg';
import { useAppDispatch, useAppSelector } from 'app/store/store.hooks';
import { getAnalyzeChannelsChannelShareModel } from 'app/store/reducers/analyzeChannels.reducer';
import { IAnalyzeChannelsChannelShareParams } from 'entities/AnalyzeChannels/AnalyzeChannels.models';
import { ChannelShareChart } from 'entities/AnalyzeChannels/components/ChannelShareChart';

interface IComponentProps {
  dateRange: string;
  params?: IAnalyzeChannelsChannelShareParams;
}

export const AnalyzeChannelsChannelShareBlock: FC<IComponentProps> = ({ dateRange, params }) => {
  const dispatch = useAppDispatch();

  const { analyzeChannelsChannelShareModel, analyzeChannelsChannelShareModelLoading } = useAppSelector(
    (state) => state.analyzeChannels
  );

  useEffect(() => {
    dispatch(getAnalyzeChannelsChannelShareModel(params));
  }, [params?.storeCode, params?.week]);

  return (
    <div className="ac-block">
      <div className="ac-block__header">
        <span className="ff-medium fs-xs">{dateRange}</span>
        <WarningCircle className="icon-gray" />
      </div>

      <div className="ac-block__body">
        {analyzeChannelsChannelShareModelLoading ? (
          <Skeleton active paragraph={{ rows: 4 }} title={false} />
        ) : (
          <ChannelShareChart data={analyzeChannelsChannelShareModel} />
        )}
      </div>
    </div>
  );
};
